import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ItemDetailFragmentDoc } from '../fragments/item.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetItemsAtLocationQueryVariables = Types.Exact<{
  location_id: Types.Scalars['ID'];
  filter?: Types.InputMaybe<Types.TrackableItemFilterInput>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  page_size?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetItemsAtLocationQuery = { __typename?: 'Query', getItemsAtLocation: Array<{ __typename?: 'Item', id: string, name: string, arrival_date: string, booked_by_user_id?: string | null, booked_by_user_name?: string | null, item_type: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory, archived: boolean, epc_asset_id: number } }> };


export const GetItemsAtLocationDocument = gql`
    query GetItemsAtLocation($location_id: ID!, $filter: TrackableItemFilterInput, $page: Int, $page_size: Int) {
  getItemsAtLocation(
    location_id: $location_id
    filter: $filter
    page: $page
    page_size: $page_size
  ) {
    ...ItemDetail
  }
}
    ${ItemDetailFragmentDoc}`;

/**
 * __useGetItemsAtLocationQuery__
 *
 * To run a query within a React component, call `useGetItemsAtLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemsAtLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemsAtLocationQuery({
 *   variables: {
 *      location_id: // value for 'location_id'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      page_size: // value for 'page_size'
 *   },
 * });
 */
export function useGetItemsAtLocationQuery(baseOptions: Apollo.QueryHookOptions<GetItemsAtLocationQuery, GetItemsAtLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemsAtLocationQuery, GetItemsAtLocationQueryVariables>(GetItemsAtLocationDocument, options);
      }
export function useGetItemsAtLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemsAtLocationQuery, GetItemsAtLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemsAtLocationQuery, GetItemsAtLocationQueryVariables>(GetItemsAtLocationDocument, options);
        }
export type GetItemsAtLocationQueryHookResult = ReturnType<typeof useGetItemsAtLocationQuery>;
export type GetItemsAtLocationLazyQueryHookResult = ReturnType<typeof useGetItemsAtLocationLazyQuery>;
export type GetItemsAtLocationQueryResult = Apollo.QueryResult<GetItemsAtLocationQuery, GetItemsAtLocationQueryVariables>;